import {SkinGrayColorPalette} from "../../../core/gd/skin/skin-palette/@type";
import {SkinTheme} from "../@const";
import GrayPalette_GoodDay from "../classic/gray-palette";

const ASANA_LIGHT : SkinGrayColorPalette = {

    // Colors from Arthur
    'palette-gray-0'    : '#FAFBFC',
    'palette-gray-1'    : '#FAFBFC',
    'palette-gray-2'    : '#FAFBFC',
    'palette-gray-2-value': '#FAFBFC',
    'palette-gray-3'    : '#F7F8FA',
    'palette-gray-4'    : '#ECEFF3',
    'palette-gray-5'    : '#ECEFF3',
    'palette-gray-6'    : '#E6EBEF',
    'palette-gray-7'    : '#DADDE1',
    'palette-gray-8'    : '#CDD2D7',
    'palette-gray-9'    : '#7E8B98',
    'palette-gray-10'   : '#58697A',
    'palette-gray-11'   : '#4E5D6B',
}

// This is dark blue
const ASANA_DARK: SkinGrayColorPalette = {
    'palette-gray-0'    : '#141617',
    'palette-gray-1'    : '#1D1F21',
    'palette-gray-2'    : '#1D1F21',
    'palette-gray-2-value': '#1D1F21',
    'palette-gray-3'    : '#343537',
    'palette-gray-4'    : '#4A4C4D',
    'palette-gray-5'    : '#4A4C4D',
    'palette-gray-6'    : '#616264',
    'palette-gray-7'    : '#77797A',
    'palette-gray-8'    : '#8E8F90',
    'palette-gray-9'    : '#A5A5A6',
    'palette-gray-10'   : '#BBBCBC',
    'palette-gray-11'   : '#D2D2D3'
}

const DEFAULT_PALETTE = SkinTheme.LIGHT // SkinTheme used like key for palette dictionary


const debug = false
// const debug = "GrayPalette_Asana"

export default class GrayPalette_Asana extends GrayPalette_GoodDay{

    constructor(currentPalette = DEFAULT_PALETTE) {

        super(currentPalette)

        // SkinTheme used like key for palette dictionary !!!
        this.palettes = {
            [SkinTheme.LIGHT]   : ASANA_LIGHT,
            [SkinTheme.DARK]    : ASANA_DARK
        }

        this.setPalette(currentPalette)

        debug && console.log(debug, 'constructor', this.palettes[this.currentPalette])
    }

    lightPalettes() {
        return [
            SkinTheme.LIGHT,
            // 'light-2',
            // 'light-3',
            // 'light-4',
            // 'light-5',
        ]
    }

    // getColorHEX(index:number) {
    //     // @ts-ignore
    //     return PALETTES[this.currentPalette] ? '#{0}'.f(PALETTES[this.currentPalette][index]) : '#000000'
    // }
}
